import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DEACTIVATEUSER = gql`
  mutation setUserDeactivate($id: ID!) {
    setUserDeactivate(id: $id)
  }
`;
function DeactivateUser({ id, name, children, onDeactivateUser }) {
    const [runDeactivateUser, setDeactivateUser] = useMutation(DEACTIVATEUSER, {
        onCompleted({ setUserDeactivate }) {
          if (setUserDeactivate) {
            message.success(`کاربر ${name ? name : ""} غیرفعال شد.`);
            onDeactivateUser();
          } else {
            message.error("متاسفانه مشکلی پیش آمده! کاربر غیرفعال نشد.");
          }
        },
        onError() {
          message.error("متاسفانه مشکلی پیش آمده! کاربر غیرفعال نشد.");
        },
      });
      const doDeactivateUser = () => {
        runDeactivateUser({
          variables: { id },
        });
      };
    return (
        <>
        <Popconfirm
          title={`غیرفعال کردن ${name ? name : "کاربر"}?`}
          okText="غیرفعال کردن"
          cancelText="خیر"
          onConfirm={doDeactivateUser}
        >
          <span>{children}</span>
        </Popconfirm>
      </>
    );
}

export default DeactivateUser;